const $inject = ['$q', '$state', 'itinerariesService', 'seatMapService'];

const stateResolveService = function ($q, $state, itinerariesService, seatMapService) {
  let service = {
    setActivePax,
    setActiveSeatMap,
    setTransport,
  };

  function setActivePax($stateParams, deferred) {
    if ($stateParams.source == 'livebooking') {
      itinerariesService.postModifyCurrent($stateParams.paxId, true).then((itinerary) => {
        $state.go('app.seatmaps', { itineraryId: itinerary.Identifier, paxId: itinerary.Passengers[0].Identifier });
        deferred.resolve();
      });
      return deferred.promise;
    }
    itinerariesService.get($stateParams.itineraryId).then(() => {
      seatMapService.init(itinerariesService.itinerary.Passengers, $stateParams.paxId);

      const activePaxId = seatMapService.findIdentifierIn($stateParams.paxId, itinerariesService.itinerary, 'Passengers');

      if (activePaxId) {
        deferred.resolve();
      } else {
        deferred.reject('No passenger found');
      }
    });

    return deferred.promise;
  }

  function setActiveSeatMap($stateParams, deferred) {
    const activePax = seatMapService.findIdentifierIn($stateParams.activePaxId, seatMapService, 'paxArray');

    if (!activePax) {
      seatMapService.error = true;
      deferred.reject('No passenger found');
      return;
    }

    seatMapService.setActive(activePax, 'activePax');

    const flight = seatMapService.findIdentifierIn($stateParams.flightId, seatMapService.activePax, 'Flights');

    if (!flight) {
      seatMapService.error = true;
      deferred.reject('No flight found');
      return;
    }

    flight.showStops = true;
    flight.seatmaps = true;
    seatMapService.setActive(flight, 'activeFlight');

    if (!seatMapService.activeSeatMap) {
      //seatMapService.activeSeatMap = true;

      seatMapService.get($stateParams.itineraryId, $stateParams.activePaxId, $stateParams.flightId).then((data) => {
        flight.transports = data.Transport;
        service.setTransport($stateParams.transportIndex, flight);

        deferred.resolve();
      });
    } else {
      service.setTransport($stateParams.transportIndex, flight);

      deferred.resolve();
    }

    return deferred.promise;
  }

  function setTransport(transportIndex, flight) {
    if (flight.transports.length === 0) {
      return;
    }

    seatMapService.setActiveSeatMap(flight.transports[transportIndex]);
    seatMapService.setActive(flight.transports[transportIndex], 'activeTransport');

    if (seatMapService.activeSeatMap.Decks.length > 0) {
      seatMapService.setActive(seatMapService.activeSeatMap.Decks[0], 'activeDeck');
      seatMapService.activeDeck.formatted = seatMapService.buildDeck(seatMapService.activeDeck);
    }
  }

  return service;
};

stateResolveService.$inject = $inject;

export default stateResolveService;



// WEBPACK FOOTER //
// ./src/services/stateResolveService.js